import { render, staticRenderFns } from "./second.vue?vue&type=template&id=3c586a00&scoped=true"
import script from "./second.vue?vue&type=script&lang=js"
export * from "./second.vue?vue&type=script&lang=js"
import style0 from "./second.vue?vue&type=style&index=0&id=3c586a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c586a00",
  null
  
)

export default component.exports